var caseWorld = require('./casefactory');

var caseWorldController;

function bootstrap() {
    caseWorldController = caseWorld.getCaseWorldController();
    caseWorldController.on('init', setupCanvasControls);
}

function setupCanvasControls () {
    var $canvas = $('canvas');
    var cameraPositioningIsActive = true;
    $('[data-camera-position]').click(function (e) {
        if (cameraPositioningIsActive && !caseWorldController.isStartAnimationActive()) {
            var $this = $(this);
            cameraPositioningIsActive = false;
            $('[data-camera-position]').removeClass('tr-prod-media-active');
            $this.addClass('tr-prod-media-active');

            caseWorldController.moveCameraTo($this.attr('data-camera-position'));

            if (Detector.webgl) {
                caseWorldController.once('cameraAnimationDone', function () {
                    setTimeout(function () {
                        cameraPositioningIsActive = true;
                    }, 100);

                });
            } else {
                cameraPositioningIsActive = true;
            }
        }
    });
    $canvas.click(function () {
        if (Detector.webgl) {
            $('[data-camera-position]').removeClass('tr-prod-media-active');
        }
    });

    var $zoomIn = $('[data-zoom-in]');
    var intervalId = null;
    $zoomIn.mousedown(function () {
        caseWorldController.zoom('zoom_in');
    });

    var $zoomOut = $('[data-zoom-out]');
    $zoomOut.mousedown(function () {
        caseWorldController.zoom('zoom_out');

    });

    $canvas
        .mousedown(function () {
            caseWorldController.startAction();
        })
        .mouseup(function () {
            caseWorldController.endAction();
        })
        .mousewheel(function (e) {
            e.preventDefault();
            var caseWorldView = caseWorldController.getCaseWorldView();

            if (e.deltaY === 1) {
                $zoomIn.trigger('mousedown');
            } else {
                $zoomOut.trigger('mousedown');
            }

        });
}

module.exports = {bootstrap};


// WEBPACK FOOTER //
// ./js/caseconfigurator/casefactory/canvasControls.js